import React from 'react';
import { Outlet } from 'react-router-dom';
import { TenantProvider } from '../../contexts/TenantContext';
import type { TenantId } from '../../config/tenant';

interface TenantLayoutProps {
  tenantId: TenantId;
}

/**
 * 租户路由布局
 * 静态租户路由（/cn、/intl）显式提供租户上下文
 */
const TenantLayout: React.FC<TenantLayoutProps> = ({ tenantId }) => {
  return (
    <TenantProvider tenantOverride={tenantId}>
      <Outlet />
    </TenantProvider>
  );
};

export default TenantLayout;
